module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_9",
    attrs: {
      "id": "calibre_pb_3"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }), _vm._v(" "), _c('h1', {
    staticClass: "block_1",
    attrs: {
      "id": "toc_id_5"
    }
  }, [_vm._v("Endorsements")]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_11"
  }, [_c('i', {
    staticClass: "calibre1"
  }, [_vm._v("Nazar’s Journey")]), _vm._v(" is a moving and thought-provoking work of historical fiction that depicts the real events of the Nineveh Plains of Iraq in August of 2014. The novel skilfully weaves together themes of war, persecution, redemption, and faith, inviting readers to imagine themselves in the situation of the characters, unable to return to their homes. The story follows Nazar, a young Christian boy who is forced into adulthood by the crisis that befalls his village. As he makes his way to safety with others, we’re taken on a journey that is both harrowing and inspiring. Along the way, Nazar encounters both profound evil and the consistent presence and protection of God’s love and providence.")]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_11"
  }, [_vm._v("Author Paul Mascia’s writing is both poetic and spiritual, creating a vivid and immersive reading experience. The characters are well-drawn and relatable, and their journeys will stay with readers long after they have finished the book.")]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("As a native Christian Iraqi, "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("Nazar’s Journey")]), _vm._v(" sparked many emotions and memories of my ancestral land in northern Iraq. My favourite passage was this: We have lived through so much sorrow in our land now, so many thousands who have lost fathers or mothers or brothers or sisters. So many badly hurt or wounded. So many homes and shops abandoned—so much destruction—everywhere. Let us not lose hope, even if we don’t understand where the good Lord is leading us, or what the future may bring.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Weam Namou is the Executive Director of the Chaldean Cultural Centre in Michigan, an Eric Hoffer award-winning author of 16 books, and multi-award-winning filmmaker of two feature films.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_13"
  }, [_vm._v("*************")]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }, [_vm._v("As a devout Muslim and a scholar of Islam, I loved reading "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("Nazar’s Journey")]), _vm._v(". It is an extraordinary piece of historical fiction, very well written, with many compelling moral and spiritual themes. I was inspired by the Muslim characters in this evocative story. The device of the Skylark was particularly beautiful. In our violent and tumultuous world, the author presents his hopeful vision for a future of cooperation and charity among peaceful Muslims and sincere Christians.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }, [_vm._v("Ismail Royer, Director of Islam and Religious Freedom, Religious Freedom Institute, Washington, DC.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_13"
  }, [_vm._v("*************")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }, [_c('i', {
    staticClass: "calibre1"
  }, [_vm._v("Nazar’s Journey")]), _vm._v(" is a beautiful gem of a story. In the midst of terror, war, and oppression among modern-day Christians in the Middle East, "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("Nazar’s Journey")]), _vm._v(" tells a tale of persistent faith, hope, and redemption.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }, [_vm._v("Dr. Aaron Urbanczyk, Professor of English, Franciscan University, Steubenville.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_13"
  }, [_vm._v("*************")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }, [_vm._v("This delightful book, a tale of love and hope in a time of terror, brings the terrible suffering of Iraqi Christians, so ignored by most in the West, to our attention. Having visited Nineveh, the ancient home of Iraqi Christians since the time of the Apostles, I know that this lovely story has an authenticity and simplicity which reflect the deep truths it tells. A story, like this one, allows the statistics about persecuted Christians to be given a name and a face.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }, [_vm._v("Father Benedict Kiely, Founder of Nasarean, org, which helps persecuted Christians globally.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_13"
  }, [_vm._v("*************")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }, [_vm._v("A lack of appreciation for the witness of the ancient Churches of the Middle East is one of the blind spots of the Christian West. Many modern Christians are virtually unaware that "), _c('span', {
    staticClass: "text_"
  }, [_vm._v("vibrant Christian communities, though perennially")]), _vm._v(" threatened, still exist in Syria, Iraq, and Iran, and elsewhere in the region, rooted in traditions that hearken back to apostolic times.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }, [_vm._v("Paul T. Mascia’s lyrical saga, "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("Nazar’s Journey")]), _vm._v(", takes us into that world—a world ripped from today’s headlines, characterised by crisis, instability, war, flight, and exile. And by faith, humanity, resourcefulness, loyalty, and hope. As a former war correspondent, I can attest to the realism and skill with which Mascia paints the dizzying disorientations of violent conflict, the sudden rending of the fabric of families, the chaos of refugees frantic to survive.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }, [_vm._v("But the “journey” of the title is not merely a chronicle of war and survival—it is a chronicle of a spiritual journey as well, a “coming of age” novel about a youth who discovers inner resources in the midst of war, and the insights which only faith can provide.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }, [_c('i', {
    staticClass: "calibre1"
  }, [_vm._v("Nazar’s Journey")]), _vm._v("—a tale with all the simplicity of a Medieval legend and all the timeliness of this morning’s newscast.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }, [_c('span', {
    staticClass: "text_"
  }, [_vm._v("Gabriel Meyer is an award-winning foreign war")]), _vm._v(" correspondent and the author of "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("In the Shade of the Terebinth: Tales of a Night Journey")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "block_15",
    attrs: {
      "id": "calibre_pb_4"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75f970fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_004.vue
// module id = 75
// module chunks = 0